var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SponsorsDataProvider',[_c('tappin-banner',{ref:"bannerWc"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }